module.exports = __webpack_public_path__ + "img/theme14.b405dfb7.png";